import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Card from "components/card";
import InputField from "components/fields/InputField";
import { axiosInstance } from "../../../../utils/axiosInstance";
import Loader from "react-spinners/PropagateLoader";
import Notification from "components/alert/Notification";
import TextEditor from "components/fields/TextEditor";
import {
    FaAngleLeft,
} from "react-icons/fa";

const UserForm = () => {
    const { id } = useParams();
    const [errorMessage, setErrorMessage] = useState("");
    const [message, setMessage] = useState("");
    const [name, setName] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [userRole, setUserRole] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();



    const handleErrorMessage = (text) => {
        setMessage('');
        setErrorMessage(text);
        window.scrollTo(0, 0);
    }
    const handleMessage = (text) => {
        setMessage(text);
        setErrorMessage('');
        window.scrollTo(0, 0);
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        handleErrorMessage("");

        if (name && username && userRole && password) {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('username', username);
            formData.append('password', password);
            formData.append('role', userRole);

            try {
                const response = await axiosInstance.post('api/AdminRole/CreateUser', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                });
                handleMessage("عملیات با موفقیت انجام شد.")
                setLoading(false);

            } catch (error) {

                setLoading(false);
                if (error.response && error.response.status === 400) {

                    handleErrorMessage(error.response.data);
                }
                else {
                    console.log("error in create user : ", error);
                    handleErrorMessage("خطا در ارتباط با سرور");
                }
            }
        }
        else {
            setLoading(false);
            handleErrorMessage("تمامی فیلد ها باید پر شوند");
        }
    };

    const closeNotif = () => {
        handleMessage('');
    }
    const handleOption = (e) => {
        setUserRole(e.target.innerText)
        toggleDropdown();
    }
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    useEffect(() => {
        const fetchRoles = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.get(`api/AdminRole/GetAllRoles`);
                setRoles(response.data.map(x => x.name))
                setLoading(false);
            } catch (error) {
                console.error('Error fetching Roles:', error);
                setLoading(false);
            }
        };
        fetchRoles();
    }, [])
    return (
        <Card extra={"w-full p-4 mt-8 flex justify-center"}>
            <div className="flex justify-end">
                <button onClick={() => navigate("/admin/management")}
                    className=" flex w-max items-center mt-4 px-6 p-3 rounded-xl gap-1 font-bold text-white dark:text-gray-800 text-md bg-cyan-500 hover:bg-cyan-600">
                    بازگشت
                    <FaAngleLeft className="  h-6 w-6" />
                </button>
            </div>
            {loading ?
                <Notification
                    text={<div className="flex gap-2 ">درحال دریافت اطلاعات،لطفا صبور باشید ...</div>}
                    type='success'
                />
                : null}
            <Notification
                text={errorMessage}
                type='error'
                closeNotification={() => setErrorMessage('')}
            />
            <Notification
                text={message}
                type='success'
                closeNotification={() => setMessage('')}
            />

            <form className="mt-4" onSubmit={handleSubmit}>
                {/* name */}
                <InputField
                    variant="management"
                    extra="mb-3 "
                    label="نام"
                    placeholder=""
                    id="name"
                    disabled={loading}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                />
                {/* user Name */}
                <InputField
                    variant="management"
                    extra="mb-3 "
                    label="نام کاربری"
                    placeholder=""
                    id="userName"
                    disabled={loading}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    type="text"
                />
                {/* password */}
                <InputField
                    variant="management"
                    extra="mb-3 "
                    label="رمزعبور"
                    placeholder=""
                    id="password"
                    disabled={loading}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="text"
                />
                {/* role */}
                <div className="flex flex-col ">
                    <label className="font-bold text-sm  dark:text-white  mb-3 whitespace-nowrap text-gray-800">
                        نقش کاربر :
                    </label>
                    <button
                        id="dropdownDefaultButton"
                        onClick={toggleDropdown}
                        className="text-white w-full h-12 flex justify-between lg:font-medium text-sm lg:text-base bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg px-5 py-2.5 text-center items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        type="button"
                    >
                        {roles.length > 0 ? (userRole? userRole:"انتخاب کنید") : <div className="h-5 flex items-center justify-center w-full mb-2"><Loader loading="true" color="#fff" /></div>}

                        <svg
                            className="w-2.5 h-2.5 ms-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 10 6"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="m1 1 4 4 4-4"
                            />
                        </svg>
                    </button>
                    {isOpen && (
                        <div
                            id="dropdown"
                            className="z-10 w-full mx-3 absolute right-0 mt-20 bg-gray-100 divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700"
                        >
                            <ul
                                className=" text-sm text-gray-700 dark:text-gray-200"
                                aria-labelledby="dropdownDefaultButton"
                            >
                                {roles.map((name, index) => (
                                    <li onClick={handleOption} key={index} value="product_id" className="block px-4 text-right py-2 hover:bg-gray-300 dark:hover:bg-gray-600 dark:hover:text-white hover:cursor-pointer">
                                        <p className="font-bold">{name}</p>
                                    </li>
                                ))}

                            </ul>
                        </div>
                    )}
                </div>


                <button type="submit" className="linear mt-12 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                    {loading ? <div className="h-5 flex items-center justify-center mb-2"><Loader loading="true" color="#fff" /></div> : "افزودن"}
                </button>

            </form>
        </Card>
    )
}

export default UserForm;